// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ServiceNotification_wrap__124F8","in":"ServiceNotification_in__SqDc7","text":"ServiceNotification_text__3w2q5","action":"ServiceNotification_action__1Hgr7"};